function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaypal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 18
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.555 4.328C12.598 2.102 10.738.395 8.18.395H2.883a.51.51 0 0 0-.508.43L.25 13.901a.4.4 0 0 0 .098.336c.078.09.195.145.32.145h3.137l-.493 3.027a.4.4 0 0 0 .098.336.41.41 0 0 0 .32.145h2.555q.182-.002.324-.121c.094-.079.11-.188.13-.31l.75-4.355a.65.65 0 0 1 .175-.355.43.43 0 0 1 .3-.121h1.563c2.508 0 4.633-1.758 5.024-4.203.273-1.735-.48-3.317-1.996-4.098m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#001c64",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.48 9.559-.78 4.89-.49 3.063a.415.415 0 0 0 .415.48h2.707a.51.51 0 0 0 .508-.43l.715-4.457a.52.52 0 0 1 .511-.43h1.59c2.508 0 4.633-1.804 5.024-4.25.277-1.734-.61-3.316-2.125-4.097q-.006.276-.047.55c-.39 2.446-2.516 4.25-5.024 4.25H4.992a.52.52 0 0 0-.512.43m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#0070e0",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.7 14.45H.554a.42.42 0 0 1-.32-.15.4.4 0 0 1-.094-.331L2.26.695a.51.51 0 0 1 .512-.43H8.18c2.558 0 4.418 1.837 4.375 4.063a4.8 4.8 0 0 0-2.203-.52H5.844a.52.52 0 0 0-.512.434L4.484 9.56Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#003087",
    fillOpacity: 1
  }
}));
export default SvgPaypal;